import React, { useEffect, useState } from 'react';

export default function ScrollToTop() {
	const [ scrollState, setScrollState ] = useState({ showtopbutton: false, intervalId: 0 });

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const scrollToTop = () => {
		let intervalId = setInterval(() => {
			if (window.pageYOffset === 0) {
				clearInterval(intervalId);
			}
			window.scroll(0, window.pageYOffset - 10);
		}, 1);
		setScrollState({
			showtopbutton: false,
			intervalId: intervalId
		});
	};

	const handleScroll = () => {
		let showButton = window.pageYOffset > window.innerHeight / 2;
		setScrollState({ ...scrollState, showtopbutton: showButton });
	};

	return (
		<button
			variant="blank"
			className={'scroll-to-top ' + (scrollState.showtopbutton ? 'active' : '')}
			onClick={() => scrollToTop()}
		/>
	);
}
